import { useState } from 'react';
import { Link } from 'react-router-dom';

type Tab = 'enrollment' | 'info' | 'history';

export default function SubjectTabs() {
  const [activeTab, setActiveTab] = useState<Tab>('enrollment');

  const tabs: { id: Tab; label: string }[] = [
    { id: 'enrollment', label: 'Subject Enrollment' },
    // { id: 'info', label: 'Course Information' },
    // { id: 'history', label: 'Lesson History' },
  ];

  return (
    <div className="pb-3">
      <div className="flex border-b border-border-light px-4 gap-8">
        {tabs.map((tab) => (
          <Link
            key={tab.id}
            to="#"
            onClick={() => setActiveTab(tab.id)}
            className={`flex flex-col items-center justify-center border-b-[3px] pb-[13px] pt-4 ${
              activeTab === tab.id
                ? 'border-b-white text-white'
                : 'border-b-transparent text-text-secondary'
            }`}
          >
            <p
              className={`text-sm font-bold leading-normal tracking-[0.015em] ${
                activeTab === tab.id ? 'text-white' : 'text-text-secondary'
              }`}
            >
              {tab.label}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}
